module.exports = __webpack_public_path__ + "img/canada-1.b142ac4d.svg";